import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Home.css';
import Header from './Header';
import SubNav from './SubNav';

function Home() {
  const location = useLocation();
  const { user } = useAuth();
  const [isLogisticsExpanded, setIsLogisticsExpanded] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);

  // User-specific data
  const userData = {
    'elonmusk': { orderRate: '78.5', confirmRate: '80.1', inspectionCount: '2,432' },
    'likezone': { orderRate: '68.8', confirmRate: '69.8', inspectionCount: '2,122' },
    'traderb': { orderRate: '82.9', confirmRate: '85', inspectionCount: '2,234' },
    'betweeninc': { orderRate: '77.9', confirmRate: '79.2', inspectionCount: '2,513' }
  };

  const currentUserData = userData[user?.username] || userData['elonmusk'];

  // Determine active menu based on current route
  const getActiveMenu = () => {
    if (location.pathname === '/' || location.pathname === '') {
      return 'home';
    }
    if (location.pathname.startsWith('/scm/')) {
      return 'logistics';
    }
    return 'home';
  };

  const activeMenu = getActiveMenu();

  const handleMenuClick = (menu) => {
    if (menu === 'logistics') {
      setIsLogisticsExpanded(!isLogisticsExpanded);
    } else {
      setIsLogisticsExpanded(false);
    }
  };

  const carouselItems = [
    {
      title: '비즈니스 성장 파트너',
      highlight: '프리미엄 데이터',
      description: '프리미엄 데이터는 로켓 상품 매출 및 고객 구매 행동에 대한 상세한 분석으로 사업 성장을 지원하는 애널리틱스 프로그램입니다.',
      link: '/rpd/web-v2/',
      linkText: '프리미엄 데이터 보러 가기',
      image: 'https://img1a.coupangcdn.com/image/coupang/retail/sh/dashboard/premium-report.png'
    },
    {
      title: '쿠팡 고객의 목소리를 듣는 가장 빠른 방법',
      highlight: '로켓 서베이',
      description: '로켓서베이는 고객반응을 설문발송 후 하루만에 확인하여 비즈니스 Question을 빠르게 해결하는 Quick Survey 입니다.',
      link: '/rpd/shopper-insights/rocket_survey',
      linkText: '로켓 서베이 보러 가기',
      image: 'https://img1a.coupangcdn.com/image/coupang/retail/sh/dashboard/rocket-survey.png'
    },
    {
      title: '비즈니스 성장을 위한 심도있는 고객 경험 분석',
      highlight: '로켓 인사이트',
      description: '로켓 인사이트는 쿠팡 실 구매 고객을 대상으로 깊이 있게 고객경험을 분석하는 In-Depth Survey 입니다.',
      link: '/rpd/shopper-insights/rocket_insight',
      linkText: '로켓 인사이트 보러 가기',
      image: 'https://img1a.coupangcdn.com/image/coupang/retail/sh/dashboard/rocket-insight.png'
    }
  ];

  return (
    <div className="home-container">
      <Header activeMenu={activeMenu} onMenuClick={handleMenuClick} />
      {isLogisticsExpanded && <SubNav />}
      
      <div className="home-content">
        {/* Promotion Banner */}
        <div className="extra-banner">
          <div className="promotion-campaign-banner">
            <div className="card-container">
              <img className="close-icon" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgNy40MDkwMUwxNi4wNzk1IDAuMzI5NTA1QzE2LjUxODggLTAuMTA5ODM1IDE3LjIzMTIgLTAuMTA5ODM1IDE3LjY3MDUgMC4zMjk1MDVDMTguMDc2IDAuNzM1MDQ5IDE4LjEwNzIgMS4zNzMxOCAxNy43NjQxIDEuODE0NTFMMTcuNjcwNSAxLjkyMDVMMTAuNTkxIDlMMTcuNjcwNSAxNi4wNzk1QzE4LjEwOTggMTYuNTE4OCAxOC4xMDk4IDE3LjIzMTIgMTcuNjcwNSAxNy42NzA1QzE3LjI2NDkgMTguMDc2IDE2LjYyNjggMTguMTA3MiAxNi4xODU1IDE3Ljc2NDFMMTYuMDc5NSAxNy42NzA1TDkgMTAuNTkxTDEuOTIwNSAxNy42NzA1QzEuNDgxMTYgMTguMTA5OCAwLjc2ODg0NSAxOC4xMDk4IDAuMzI5NTA1IDE3LjY3MDVDLTAuMDc2MDM5NiAxNy4yNjQ5IC0wLjEwNzIzNSAxNi42MjY4IDAuMjM1OTE4IDE2LjE4NTVMMC4zMjk1MDUgMTYuMDc5NUw3LjQwOTAxIDlMMC4zMjk1MDUgMS45MjA1Qy0wLjEwOTgzNSAxLjQ4MTE2IC0wLjEwOTgzNSAwLjc2ODg0NSAwLjMyOTUwNSAwLjMyOTUwNUMwLjczNTA0OSAtMC4wNzYwMzk2IDEuMzczMTggLTAuMTA3MjM1IDEuODE0NTEgMC4yMzU5MThMMS45MjA1IDAuMzI5NTA1TDkgNy40MDkwMVoiIGZpbGw9IiM1MTVFNkEiLz4KPC9zdmc+Cg==" alt="" />
              <div className="left-part">
                <div className="title">쿠팡 메인 기획전에 내 상품을 노출 할 기회!</div>
                <a href="/promotion/campaign" target="_blank" rel="noreferrer">
                  <button className="goto-button">프로모션 신청하러 가기</button>
                </a>
              </div>
              <div className="right-part">
                <img className="banner-img" src="https://img1a.coupangcdn.com/image/mypromotion/sh_promotion_campaign_banner.png" alt="" />
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content-wrapper">
          <div className="content-left">
            {/* Required Tasks */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h5>
                  <span style={{ color: 'rgb(255, 0, 0)' }}>* </span>
                  필수진행사항 (29)
                  <i className="fa fa-question-circle"></i>
                </h5>
              </div>
              <div className="panel-body">
                <div className="list-group sh-scroll">
                  <div className="list-group-item">
                    <div className="item-header">
                      <a href="">[일반배송상품] 2026 신정 휴무일 스케줄 조사</a>
                      <span className="time-badge">한 달 전</span>
                    </div>
                    <div>안녕하세요. 쿠팡입니다. 휴무일에 따른 '일반 배송 상품'의 발주-입고 스케줄 확인을 부탁 드립니다. 물류탭 발주-입고 스케줄 메뉴의 '일반 배송 상품' 유형 필터에 접속하시어 2025-11-28 까지 응답해 주시기 바랍니다.</div>
                  </div>
                  <div className="list-group-item">
                    <div className="item-header">
                      <a href="">[일반배송상품] 2025 크리스마스 휴무일 조사</a>
                      <span className="time-badge">한 달 전</span>
                    </div>
                    <div>안녕하세요. 쿠팡입니다. 휴무일에 따른 '일반 배송 상품'의 발주-입고 스케줄 확인을 부탁 드립니다. 물류탭 발주-입고 스케줄 메뉴의 '일반 배송 상품' 유형 필터에 접속하시어 2025-11-21 까지 응답해 주시기 바랍니다.</div>
                  </div>
                  <div className="list-group-item">
                    <div className="item-header">
                      <a href="">[일반배송상품] 2025 10월 개천절, 추석, 한글날, 대체휴일 휴무일 조사_2차</a>
                      <span className="time-badge">3달 전</span>
                    </div>
                    <div>안녕하세요. 쿠팡입니다. 휴무일에 따른 '일반 배송 상품'의 발주-입고 스케줄 확인을 부탁 드립니다. 물류탭 발주-입고 스케줄 메뉴의 '일반 배송 상품' 유형 필터에 접속하시어 2025-09-16 까지 응답해 주시기 바랍니다.</div>
                  </div>
                  <div className="list-group-item">
                    <div className="item-header">
                      <a href="">[일반배송상품] 2025 10월 개천절, 추석, 한글날, 대체휴일 휴무일 조사</a>
                      <span className="time-badge">4달 전</span>
                    </div>
                    <div>안녕하세요. 쿠팡입니다. 휴무일에 따른 '일반 배송 상품'의 발주-입고 스케줄 확인을 부탁 드립니다. 물류탭 발주-입고 스케줄 메뉴의 '일반 배송 상품' 유형 필터에 접속하시어 2025-08-29 까지 응답해 주시기 바랍니다.</div>
                  </div>
                  <div className="list-group-item">
                    <div className="item-header">
                      <a href="">[일반배송상품] 2025 광복절 휴무일 조사</a>
                      <span className="time-badge">6달 전</span>
                    </div>
                    <div>안녕하세요. 쿠팡입니다. 휴무일에 따른 '일반 배송 상품'의 발주-입고 스케줄 확인을 부탁 드립니다. 물류탭 발주-입고 스케줄 메뉴의 '일반 배송 상품' 유형 필터에 접속하시어 2025-07-11 까지 응답해 주시기 바랍니다.</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Announcements */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h5>
                  공지사항 (281)
                  <span className="material-symbols-rounded">help</span>
                  <a className="sh-link" href="/bulletin/list">
                    전체보기
                    <span className="material-symbols-outlined">chevron_right</span>
                  </a>
                </h5>
              </div>
              <div className="panel-body">
                <div className="list-group sh-scroll">
                  <div className="list-group-item">
                    <div className="close-icon">
                      <i className="fa fa-times-circle"></i>
                    </div>
                    <div className="item-header">
                      <a href="">[법무] 상품정보제공고시 제조국 표기 확인 요청</a>
                      <span className="time-badge">5일 전</span>
                    </div>
                    <div>상품정보제공고시 제조국 표기 점검 안내</div>
                  </div>
                  <div className="list-group-item">
                    <div className="close-icon">
                      <i className="fa fa-times-circle"></i>
                    </div>
                    <div className="item-header">
                      <a href="">[법무] 친환경 인증상품 관련 정보 요청 (25.11월 인증종료 대상)</a>
                      <span className="time-badge">10일 전</span>
                    </div>
                    <div>[친환경 식품] 컴플라이언스 준수여부 확인필요 상품에 대한 OB(e-mail outbounding) 예정 안내</div>
                  </div>
                  <div className="list-group-item">
                    <div className="close-icon">
                      <i className="fa fa-times-circle"></i>
                    </div>
                    <div className="item-header">
                      <a href="">[법무] 생활화학제품 인증유효성 및 표시사항 확인 요청</a>
                      <span className="time-badge">17일 전</span>
                    </div>
                    <div>안전확인대상 생활화학제품 인증 유효성 및 표시사항 점검 안내</div>
                  </div>
                  <div className="list-group-item">
                    <div className="close-icon">
                      <i className="fa fa-times-circle"></i>
                    </div>
                    <div className="item-header">
                      <a href="">[중요] 11월 로켓배송  견적서 업데이트 안내</a>
                      <span className="time-badge">19일 전</span>
                    </div>
                    <div>2025년 12월 2일 (화) 로켓배송  상품등록 견적서가 업데이트 됩니다.</div>
                  </div>
                  <div className="list-group-item">
                    <div className="close-icon">
                      <i className="fa fa-times-circle"></i>
                    </div>
                    <div className="item-header">
                      <a href="">[법무] 11월 필수서류 안내</a>
                      <span className="time-badge">21일 전</span>
                    </div>
                    <div>고객사께서 관심 있으실 법령 관련 정보와 법령에 맞는 쿠팡 필수서류 안내 뉴스레터를 게시하오니 업무에 참조하시길 바랍니다.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="content-right">
            {/* First Row: 4 Info Cards */}
            <div className="info-row-container">
              <div className="info-col">
                <div className="info-title">
                  <div>상품등록 방법에 대해 이미 알고 계신가요?</div>
                </div>
                <div className="info-buttons-vertical">
                  <a className="btn btn-info" target="_blank" href="/sr/registration" rel="noreferrer">
                    <span>개별 상품 등록 하기</span>
                  </a>
                  <a className="btn btn-info" target="_blank" href="/qvt/registration" rel="noreferrer">
                    <span>대량 상품 등록 하기</span>
                  </a>
                  <a className="btn btn-info" target="_blank" href="/qvt/conversion/wing" rel="noreferrer">
                    <span>Wing 상품 추출/등록 하기</span>
                  </a>
                </div>
              </div>
              <div className="info-col">
                <div className="info-title">
                  <div>쿠팡 공급 요청을 확인하셨나요?</div>
                </div>
                <div>
                  <ul className="status-list">
                    <li>
                      <div className="supply-label">🚨 우선 공급 추천:</div>
                      <div>0</div>
                    </li>
                    <li>
                      <div className="supply-label">✔️ 신규 요청:</div>
                      <div>0</div>
                    </li>
                    <li>
                      <div className="supply-label">✔️ 재요청:</div>
                      <div>0</div>
                    </li>
                  </ul>
                  <a className="btn btn-info" target="_blank" href="/scm/supply/review" rel="noreferrer">
                    <span>공급 검토</span>
                  </a>
                </div>
              </div>
              <div className="info-col">
                <div className="info-title">
                  <div>발주 확정 준비가 되셨나요?</div>
                </div>
                <div>
                  <a className="btn btn-info" target="_blank" href="/scm/purchase/order/list" rel="noreferrer">
                    <span>발주 확정 하기</span>
                  </a>
                </div>
              </div>
              <div className="info-col">
                <div className="info-title">
                  <div>상품 등록 현황이 궁금하신가요?</div>
                </div>
                <div>
                  <ul className="status-list">
                    <li>
                      <div>검수중인 상품:</div>
                      <a target="_blank" href="/qvt/wims?state=INSPECTION" rel="noreferrer">
                        <span className="status-count">{currentUserData.inspectionCount}</span>
                      </a>
                    </li>
                    <li>
                      <div>반려회신 필요:</div>
                      <a target="_blank" href="/qvt/wims?isReplyNeeded=true" rel="noreferrer">
                        <span className="status-count">0</span>
                      </a>
                    </li>
                  </ul>
                  <a className="btn btn-info" target="_blank" href="/qvt/wims" rel="noreferrer">
                    <span>상품 등록 상태 확인</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Help Search Bar - Full Width */}
            <div className="help-search-bar">
              <h4>도움이 필요하세요?</h4>
              <form className="help-search-form">
                <div className="search-input-group">
                  <input type="text" placeholder="검색할 '단어'를 입력해 주세요." />
                  <button type="submit">
                    <span className="material-symbols-rounded">search</span>
                  </button>
                </div>
              </form>
            </div>

            {/* Second Row: Statistics Grid (납품률, 입고기준 미준수, Carousel) */}
            <div className="stats-grid">
              <div className="panel panel-default stat-panel">
                <div className="panel-heading">
                  <h5>
                    납품률
                    <span className="material-symbols-rounded">help</span>
                    <a href="/rpd/web-v2/free/fillrate" className="sh-link">
                      <span>자세히 보기</span>
                      <span className="material-symbols-outlined">chevron_right</span>
                    </a>
                  </h5>
                </div>
                <div className="panel-body">
                  <div className="stat-period">12/14 ~ 12/20</div>
                  <div className="stat-values-row">
                    <div className="stat-value-col">
                      <div>
                        <span>발주대비 납품률</span>
                        <span className="material-symbols-rounded">help</span>
                      </div>
                      <span className="value-large">{currentUserData.orderRate}</span>
                      <span className="value-unit">%</span>
                    </div>
                    <div className="stat-value-col">
                      <div>
                        <span>확정대비 납품률</span>
                        <span className="material-symbols-rounded">help</span>
                      </div>
                      <span className="value-large">{currentUserData.confirmRate}</span>
                      <span className="value-unit">%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="panel panel-default stat-panel">
                <div className="panel-heading">
                  <h5>
                    입고기준 미준수
                    <span className="material-symbols-rounded">help</span>
                    <a href="/rpd/web-v2/free/fc-compliance" className="sh-link">
                      <span>자세히 보기</span>
                      <span className="material-symbols-outlined">chevron_right</span>
                    </a>
                  </h5>
                </div>
                <div className="panel-body">
                  <div className="stat-period">12/14 ~ 12/20</div>
                  <div className="stat-values-row">
                    <div className="stat-value-col">
                      <div>
                        <span>미준수 수량</span>
                        <span className="material-symbols-rounded">help</span>
                      </div>
                      <span className="value-large">0</span>
                      <span className="value-unit"></span>
                    </div>
                    <div className="stat-value-col">
                      <div>
                        <span>미준수 비율%</span>
                        <span className="material-symbols-rounded">help</span>
                      </div>
                      <span className="value-large">0</span>
                      <span className="value-unit">%</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Carousel */}
              <article className="carousel-panel">
                <aside className="carousel-controls">
                  <span className="carousel-indicator">
                    <strong>{carouselIndex + 1}</strong> / 3
                  </span>
                  <button 
                    className="carousel-btn" 
                    onClick={() => setCarouselIndex(carouselIndex > 0 ? carouselIndex - 1 : 2)}
                  >
                    <span className="material-symbols-outlined">chevron_left</span>
                  </button>
                  <button 
                    className="carousel-btn"
                    onClick={() => setCarouselIndex(carouselIndex < 2 ? carouselIndex + 1 : 0)}
                  >
                    <span className="material-symbols-outlined">chevron_right</span>
                  </button>
                </aside>
                <section className="carousel-content">
                  <h1>
                    <span>{carouselItems[carouselIndex].title} </span>
                    <strong>{carouselItems[carouselIndex].highlight}</strong>
                  </h1>
                  <p className="carousel-description">
                    <span>{carouselItems[carouselIndex].description}</span>
                  </p>
                  <p className="carousel-footer">
                    <a className="btn btn-info" href={carouselItems[carouselIndex].link}>
                      <span>{carouselItems[carouselIndex].linkText}</span>
                    </a>
                    <img width="100" src={carouselItems[carouselIndex].image} alt="" />
                  </p>
                </section>
              </article>
            </div>

            {/* Did You Know Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h5>알고계셨나요?</h5>
              </div>
              <div className="panel-body">
                <div className="did-you-know-content">
                  <p className="intro-text">
                    귀사에서 미납하는 상품들은 귀사의 매출손실로 직결됩니다. 불안정한 납품률에 따라 향후 발주량에도 영향을 주어 귀사의 생산 및 판매 계획에도 문제를 일으킬 수 있으니 최적의 납품률이 유지될 수 있도록 당부 드립니다.
                  </p>
                  <ul className="info-list">
                    <li className="info-item-header">
                      <span>귀사의 안정적인 생산 및 납품계획을 위해 무료로 제공되는 쿠팡의 판매예상정보를 이용해 보세요.</span>
                    </li>
                    <li>
                      <span><a href="/rpd/web-v2/free/tip-forecast">판매예상 정보 리포트</a></span>
                    </li>
                    <br />
                    <li className="info-item-header">
                      <span>
                        쿠팡의 입고기준 미준수 상품들은 납품 후 검수 시 물류센터에서 회송 대상입니다. <br />
                        이는 귀사의 불필요한 물류비를 유발시킬 수 있으므로 쿠팡의 입고 메뉴얼을 통해 항시 쿠팡의 입고기준이 준수될 수 있도록 당부 드립니다.
                      </span>
                    </li>
                    <li><span><a href="/help/view?no=200">공급자 입고 매뉴얼</a></span></li>
                    <li><span><a href="/help/view?no=201">신선 물류센터 입고 매뉴얼</a></span></li>
                    <br />
                    <li><span><a href="/help/view?no=971">코어 크로스닥 입고 매뉴얼</a></span></li>
                    <br />
                    <li className="info-item-header">
                      <span>상품 등록에서 납품까지 로켓배송 운영에 대한 이해를 돕기위한 판매자 교육 채널입니다. 많은 활용 바랍니다.</span>
                    </li>
                    <li>
                      <span>
                        <a target="_blank" href="https://www.youtube.com/channel/UCEoXbfzxKt5NbmYmnheRnwg" rel="noreferrer">
                          쿠팡 로켓배송 판매자 교실
                        </a>
                        <span className="material-icons external-icon">launch</span>
                      </span>
                    </li>
                    <br />
                    <li className="info-item-header">
                      <span>쿠팡 애널리틱스는 판매 트렌드와 고객 구매 행동에 대한 상세한 분석을 통해 귀사의 로켓 사업 성장을 지원합니다.</span>
                    </li>
                    <li>
                      <span>프리미엄 데이터는 효율적인 영업 활동과, 장기적 마케팅 전략 도출을 위한 비즈니스 인텔리전스 분석 모듈입니다.</span>
                    </li>
                    <br />
                    <li className="info-item-header">
                      <span>2023년 1월, 프리미엄 데이터 2.0이 더욱 다양하고 폭넓은 분석 모듈과 지표로 개편되었습니다. 지금 확인하시고, 비즈니스 성장을 위한 기회를 만나 보세요.</span>
                    </li>
                    <li>
                      <span><a href="/rpd/web-v2">프리미엄데이터 2.0 바로가기</a></span>
                    </li>
                    <li>
                      <span>
                        <a rel="noreferrer" href="https://youtu.be/cS9pniXisLA" target="_blank">
                          프리미엄데이터 2.0 소개 영상 확인하기
                          <span className="material-icons external-icon">launch</span>
                        </a>
                      </span>
                    </li>
                    <br />
                    <li className="info-item-header">
                      <span>로켓서베이는 고객반응을 설문발송 후 하루만에 확인하여 비즈니스 Question을 빠르게 해결하는 Quick Survey 입니다.</span>
                    </li>
                    <li>
                      <span><a href="/rpd/shopper-insights/rocket_survey" target="_blank">로켓 서베이 프로그램 알아보기</a></span>
                    </li>
                    <br />
                    <li className="info-item-header">
                      <span>로켓 인사이트는 쿠팡 실 구매 고객을 대상으로 깊이 있게 고객경험을 분석하는 In-Depth Survey 입니다.</span>
                    </li>
                    <li>
                      <span><a href="/rpd/shopper-insights/rocket_insight" target="_blank">로켓 인사이트 프로그램 알아보기</a></span>
                    </li>
                    <br />
                    <li className="info-item-header">
                      <span>
                        쿠팡 애널리틱스 프로그램과 관련하여 문의가 있으실 경우 <a href="mailto:grp_premiumdata@coupang.onmicrosoft.com">grp_premiumdata@coupang.onmicrosoft.com</a>로 연락주시기 바랍니다.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-left">
            <p className="phone">서플라이어 콜센터 : 1600-9879 (월-금 9:00-19:00)</p>
            <p className="copyright">© Copyright 2025 Coupang.com, or its affiliates. All rights reserved.</p>
          </div>
          <div className="footer-right">
            <a href="#">Speak Up 제보 / Ethics 헬프라인</a>
            <a href="#">공정거래 업무자료</a>
            <a href="#">이용약관</a>
            <a href="#">개인정보 처리방침</a>
            <a href="#">고객지원</a>
            <a href="#">은퇴로 문의</a>
            <a href="#">낮은 윤리약</a>
            <a href="#">도움말</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
